var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"drop-zone"},on:{"dragover":_vm.dragover,"drop":_vm.drop}},[_c('input',{attrs:{"type":"file","id":"file-input","accept":".glb","hidden":""},on:{"change":_vm.handleFileUpload}}),_c('label',{attrs:{"for":"file-input","id":"droptext"}},[_vm._v("Drag & drop a .glb file here.")])])
}
var staticRenderFns = []

export { render, staticRenderFns }